import { render, staticRenderFns } from "./channelOverview.vue?vue&type=template&id=b83d6d8e"
import script from "./channelOverview.vue?vue&type=script&lang=js"
export * from "./channelOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports